import React, { useEffect, useState } from "react";
import { Form, Input, Button, Radio, Card } from "antd";
import Editor from 'src/components/Editor';
import { ToastContainer, toast } from "react-toastify";
import IntlMessages from "../../../../util/IntlMessages";
import { useEditSetting } from "src/hooks/services/baseData/useEditSetting";
import { useGetSetting } from "src/hooks/services/baseData/useGetSetting";

const Add = () => {
  const [form] = Form.useForm();
  const [formLayout, setFormLayout] = useState("horizontal");
  const { mutate: onEditSetting, isLoading: loadingEdit } = useEditSetting();
  const { data: settingData, isLoading } = useGetSetting();
  const [aboutUs, setAboutUs] = useState("");

  useEffect(() => {
    if (!isLoading) {
      form.setFieldsValue(settingData);
      setAboutUs(settingData.aboutUsString);
    }
  }, [settingData]);

  const editSetting = (values) => {
    values.aboutUsString = aboutUs ;
    onEditSetting(values, {
      onSuccess: (data) => {
        toast.success(<IntlMessages id="notification.successMessage" />);
      },
      onError: (err) => {
        toast.error(<IntlMessages id="notification.errorMessage" />);
      },
    });
  };

  const formItemLayout =
    formLayout === "horizontal"
      ? {
          labelCol: {
            xs: { span: 24 },
            sm: { span: 6 },
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 14 },
          },
        }
      : null;

  return (
    <>
      <Form
        {...formItemLayout}
        form={form}
        initialValues={{
          layout: formLayout,
        }}
        onFinish={editSetting}
        autoComplete="off"
      >
        <Form.Item label="اکانت اینستاگرام" name="instagram">
          <Input />
        </Form.Item>
        <Form.Item label="اکانت تلگرام" name="telegram">
          <Input />
        </Form.Item>
        <Form.Item label="اکانت واتس اپ" name="whatsApp">
          <Input />
        </Form.Item>
        <Form.Item label="اکانت تویتتر" name="twitter">
          <Input />
        </Form.Item>
        <Form.Item label="اکانت لینکدین" name="linkedin">
          <Input />
        </Form.Item>
        <Form.Item label="شعار شرکت" name="slogan">
          <Input />
        </Form.Item>
        <Form.Item label="متن قسمت پروژه ها" name="projectsText">
          <Input />
        </Form.Item>
        <Form.Item label="متن قسمت استانداردها" name="standardsText">
          <Input />
        </Form.Item>
        <Form.Item label="متن قسمت فوتر" name="footerText">
          <Input />
        </Form.Item>
        <Form.Item label="شماره تلفن ۱ " name="phone1">
          <Input />
        </Form.Item>
        <Form.Item label="شماره تلفن ۲" name="phone2">
          <Input />
        </Form.Item>
        <Form.Item label="آدرس" name="address">
          <Input />
        </Form.Item>
        <Form.Item label="ایمیل" name="email">
          <Input />
        </Form.Item>
        <Form.Item label="درباره ی شرکت" required>
          <Editor
            value={aboutUs}
            onChange={(event, editor) => {
              const data = editor.getData();
              setAboutUs(data);
            }}
          />
        </Form.Item>
        <Form.Item>
          <Button loading={loadingEdit} type="primary" htmlType="submit">
            ذخیره
          </Button>
        </Form.Item>
      </Form>
      {/* <NotificationContainer /> */}
    </>
  );
};

export default Add;
